export { AuthenticationHomeContainer as Authentication } from './AuthenticationHomeContainer';
